import type { SxProps } from "@mui/material"

export const activeBg: (isSelected: boolean) => SxProps = (
  isSelected: boolean
) => ({
  zIndex: 1,
  display: isSelected ? "block" : "none",
  position: "absolute",
  background: "white",
  opacity: 0.3
})

export const outletContainer: (isSelected: boolean) => SxProps = (
  isSelected: boolean
) => ({
  zIndex: 2,
  opacity: isSelected ? 1 : 0.5
})

export default { activeBg, outletContainer }
